import { FormCard, Row, Col, FormGroup, Label, Switch, Select, SimpleAlert } from 'twyne-new.ui'

import PageVariablesEditorFrame from '@Components/Mergetag/PageVariablesEditorFrame'
import CodeEditor from '@Components/form/CodeEditor'

import ConsentDBAs from './ConsentDBAs'
import { templateAlias } from './formUtils'

const CONSENT_POSITION_TYPES = [{
  label: 'After Answers',
  value: 'after',
}, {
  label: 'Before Answers',
  value: 'before',
}]

const CONSENT_TYPES = {
  'tcpa-form': { dbas: true },
  'tcpa-question': { dbas: true, position: true, defaultPosition: CONSENT_POSITION_TYPES[0] },
  'tcpa-question-custom': { dbas: true, position: true },
  'tcpa-linkout-question': {},
  'tcpa-call-question': {},
}

export const hasConsentText = type => !!CONSENT_TYPES[type]

export default function ConsentText({ type, integrationData, integration, disabled, onChange, badge }) {
  const settings = CONSENT_TYPES[type]

  if (!settings) {
    return null
  }

  const data = integrationData[templateAlias[type]] || {}
  const active = data.consentTextActive || false
  const allowBidSelection = settings.dbas && (integration?.configuration?.allowBidSelection || false)

  return <Col>
    <FormCard
      render={active}
      title={<span className='flex items-center gap-2'>
        Consent text
        {badge}
      </span>}
      headerButtons={<div className='flex items-center gap-2'>
        {active && allowBidSelection ? <ConsentDBAs
          data={data.dbas}
          onChange={dbas => onChange('dbas', dbas)}
        /> : null}
        <Switch
          onChange={({ target: { checked } }) => onChange('consentTextActive', checked)}
          checked={active}
          disabled={disabled}
        />
        <Label>Active</Label>
      </div>}
    >
      <Row>
        {allowBidSelection ? <Col size='12'>
          <SimpleAlert color='warning'>
            This integration requires using the helpers to render DBA&apos;s checkbox in your consent text.
          </SimpleAlert>
        </Col> : null}
        <Col size='12'>
          <FormGroup>
            <PageVariablesEditorFrame disabled={disabled}>
              <CodeEditor
                name='consentText'
                value={data.consentText || ''}
                onChange={value => onChange('consentText', value)}
                disabled={disabled}
                resizable
                height='100px'
              />
            </PageVariablesEditorFrame>
          </FormGroup>
        </Col>
        {settings.position ? <Col size='12'>
          <FormGroup>
            <Label>Consent text position</Label>
            <Select
              value={data.consentPosition || settings.defaultPosition}
              options={CONSENT_POSITION_TYPES}
              onChange={({ value }) => onChange('consentPosition', value)}
              disabled={disabled}
            />
          </FormGroup>
        </Col> : null}
      </Row>
    </FormCard>
  </Col>
}
